import moment from 'moment';
import { HospitalSchedule, ORSchedule, daysOfWeek, Holiday } from '../ScheduleTypes';
import { ANALYTICS_API_BASE_URL } from '../../../env';

const defaultWeeklySchedule = {
  All: { startTime: '08:00', endTime: '16:00', checked: true },
  Mon: { startTime: '08:00', endTime: '16:00', checked: true },
  Tue: { startTime: '08:00', endTime: '16:00', checked: true },
  Wed: { startTime: '08:00', endTime: '16:00', checked: true },
  Thu: { startTime: '08:00', endTime: '16:00', checked: true },
  Fri: { startTime: '08:00', endTime: '16:00', checked: true },
  Sat: { startTime: '08:00', endTime: '16:00', checked: false },
  Sun: { startTime: '08:00', endTime: '16:00', checked: false },
};

const getInitialSchedule = (ORsList: any[]) => {
  const orSchedules: ORSchedule = {};
  ORsList.push({ value: 'AllORs', label: 'AllORs' });

  ORsList.forEach((or) => {
    orSchedules[or.value] = defaultWeeklySchedule;
  });

  return orSchedules;
};

const ACTION_TYPES = {
  LOAD_HOLIDAYS: 'LOAD_HOLIDAYS',
  INITIALIZE_SCHEDULE: 'INITIALIZE_SCHEDULE',
  APPLY_TO_ALL_DAYS: 'APPLY_TO_ALL_DAYS',
  UPDATE_PERIOD_PROPERTY: 'UPDATE_PERIOD_PROPERTY',
  UPDATE_DAY_SCHEDULE: 'UPDATE_DAY_SCHEDULE',
  ADD_NEW_PERIOD: 'ADD_NEW_PERIOD',
  ADD_PERIOD_HOLIDAY: 'ADD_PERIOD_HOLIDAY',
  REMOVE_PERIOD_HOLIDAY: 'REMOVE_PERIOD_HOLIDAY',
  SAVE_SCHEDULE: 'SAVE_SCHEDULE',
  REMOVE_PERIOD_SCHEDULE: 'REMOVE_PERIOD_SCHEDULE',
};

const getHolidayAPIUrl = () => {
  return ANALYTICS_API_BASE_URL + '/api/v1/proxy/holidays';
};

let holidaysList: Holiday[] = [];

const getAllHolidays = () => {
  fetch(getHolidayAPIUrl())
    .then((response) => response.json())
    .then((data) => {
      holidaysList = data.data.holidays.filter((holiday: Holiday) => holiday.public === true) || [];
      localStorage.setItem(
        'holidaysList',
        JSON.stringify(
          holidaysList.map((h) => ({
            date: h.date,
            name: h.name,
          })),
        ),
      );
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching holidays:', error);
    });
};

const scheduleReducer = (state: HospitalSchedule, action: { type: string; payload: any }) => {
  switch (action.type) {
    case ACTION_TYPES.LOAD_HOLIDAYS:
      holidaysList = JSON.parse(localStorage.getItem('holidaysList') || '[]') || [];
      if (holidaysList.length === 0 || moment(holidaysList[0].date).year() != moment().year()) {
        getAllHolidays();
      }
      return state;

    case ACTION_TYPES.INITIALIZE_SCHEDULE:
      return action.payload;

    case ACTION_TYPES.UPDATE_PERIOD_PROPERTY:
      if (action.payload.periodId === 'general') {
        // update a setting (e.g. gracePeriod) for all periods
        return state.map((period) => {
          return {
            ...period,
            [action.payload.property]: action.payload.updatedValue,
          };
        });
      }

      return state.map((period) => {
        if (period.id === action.payload.periodId) {
          return {
            ...period,
            [action.payload.property]: action.payload.updatedValue,
          };
        }
        return period;
      });

    case ACTION_TYPES.UPDATE_DAY_SCHEDULE:
      return state.map((period) => {
        if (period.id === action.payload.periodId) {
          if (action.payload.day == 'All') {
            return {
              ...period,
              schedule: {
                ...period.schedule,
                [action.payload.OR]: {
                  ...period.schedule[action.payload.OR],
                  ...Object.fromEntries(
                    daysOfWeek.map((d) => [
                      d,
                      {
                        ...action.payload.updatedValue,
                        checked:
                          d == 'All' && action.payload.updatedValue.checked == false
                            ? false
                            : ['Sat', 'Sun'].includes(d)
                            ? false
                            : true,
                      },
                    ]),
                  ),
                },
              },
            };
          } else
            return {
              ...period,
              schedule: {
                ...period.schedule,
                [action.payload.OR]: {
                  ...period.schedule[action.payload.OR],
                  [action.payload.day]: action.payload.updatedValue,
                },
              },
            };
        }
        return period;
      });

    case ACTION_TYPES.ADD_NEW_PERIOD:
      const ORsList = action.payload.ORsList || [];
      const dates = action.payload.dates;
      return [
        ...state,
        {
          id: Date.now(),
          name: 'New Period',
          startDate:
            state.length === 0
              ? dates?.from || moment().format('YYYY-MM-DD')
              : moment
                  .max(state.map((p) => moment(p.endDate)))
                  .add(1, 'day')
                  .format('YYYY-MM-DD'),
          endDate: moment
            .max(state.map((p) => moment(p.endDate)))
            .add(3, 'month')
            .format('YYYY-MM-DD'),
          applyToAllORs: true,
          schedule: getInitialSchedule(ORsList),
          holidays: JSON.parse(localStorage.getItem('holidaysList') || '[]') || [],
        },
      ] as HospitalSchedule;

    case ACTION_TYPES.ADD_PERIOD_HOLIDAY:
      return state.map((period) => {
        if (period.id === action.payload.periodId) {
          return {
            ...period,
            holidays: [...(period.holidays || []), action.payload.holiday],
          };
        }
        return period;
      });

    case ACTION_TYPES.REMOVE_PERIOD_HOLIDAY:
      return state.map((period) => {
        if (period.id === action.payload.periodId) {
          return {
            ...period,
            holidays: (period.holidays ?? []).filter(
              (holiday) => holiday.name !== action.payload.holiday.name,
            ),
          };
        }
        return period;
      });

    case ACTION_TYPES.REMOVE_PERIOD_SCHEDULE:
      return state.filter((period) => period.id !== action.payload.periodId);

    default:
      return state;
  }
};

export { scheduleReducer, ACTION_TYPES, defaultWeeklySchedule };
